import Header from "./components/Header";
import Hero from "./components/Hero";
import MarqueeBar from "./components/MarqueeBar";
import FeedSection from "./components/FeedSection";
import JokesSection from "./components/JokesSection";
import MemeWall from "./components/MemeWall";
import RankSection from "./components/RankSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MarqueeBar />
        <FeedSection />
        <JokesSection />
        <MemeWall />
        <RankSection />
        <AboutSection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}